<script setup lang="ts">
/********************
 * PROPS & EMITS     *
 ********************/
export interface InputSwitchProps {
  value?: boolean;
}
const props = withDefaults(defineProps<InputSwitchProps>(), {
  value: false,
});

const emit = defineEmits<{
  input: [value: boolean];
}>();

defineOptions({
  inheritAttrs: false,
});

/********************
 * COMPOSITIONS      *
 ********************/
const $attrs = useAttrs();

/********************
 * REFS & VARS       *
 ********************/
const listeners = computed(() => {
  return {
    ...$attrs,
    change: () => {},
    input: () => {},
  };
});

const model = computed({
  // getter
  get() {
    return props.value;
  },
  // setter
  set(newValue) {
    emit('input', newValue);
  },
});
</script>

<template>
  <label
    ref="label"
    class="m-0 h-[26px] p-0"
    :class="{ 'opacity-50': $attrs.disabled }"
  >
    <input
      v-model="model"
      class="peer/input absolute left-[-9999px]"
      type="checkbox"
      v-bind="listeners"
    />
    <span class="sr-only">switch</span>
    <span
      class="switch relative block h-[26px] w-[50px] cursor-pointer rounded-full bg-gray-light outline-none transition-all duration-300 ease-out after:absolute after:left-0.5 after:top-0.5 after:size-[22px] after:rounded-full after:bg-white after:transition-all after:content-[''] peer-checked/input:bg-primary peer-checked/input:after:left-[calc(100%-24px)] peer-checked/input:after:transition-all peer-checked/input:after:duration-300 peer-checked/input:after:ease-out peer-disabled/input:cursor-not-allowed"
    />
  </label>
</template>

<style></style>
